import { createEntityAdapter } from '@reduxjs/toolkit';

const sitelistsAdapter = createEntityAdapter();

export default sitelistsAdapter;
